import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {NestApiProvider} from "../../nest-api";
import {
  RequestAttendDataDto,
  RequestShiftDailyDto,
  RequestAddDto,
  RequestEditDto,
  RequestDeleteDto,
  ResponseCompanySettingDto, ResponseShiftDailyDto, ResponseAttendDataDto, ResponseAddDto, ResponseSaveDto, RequestUpdatePostDto,
} from "../dto/correction.dto";
import {ResponseData} from "../../nest-responses";

@Injectable()
export class CorrectionApi {

  private readonly service: string = '';
  private readonly model: string = 'sf6s/correction';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public companySetting(): Observable<ResponseData<ResponseCompanySettingDto>> {
    const method: string = 'GET';
    const func: string = 'companySetting';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseCompanySettingDto>>(method, url, params, urlParams, body);
  }

  public shiftdaily(payload: RequestShiftDailyDto): Observable<ResponseData<ResponseShiftDailyDto[]>> {
    const method: string = 'GET';
    const func: string = 'shiftdaily';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseShiftDailyDto[]>>(method, url, params, urlParams, body);
  }

  public attenddata(payload: RequestAttendDataDto): Observable<ResponseData<ResponseAttendDataDto>> {
    const method: string = 'GET';
    const func: string = 'attenddata';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseAttendDataDto>>(method, url, params, urlParams, body);
  }

  public add(payload: RequestAddDto): Observable<ResponseData<ResponseAddDto>> {
    const method: string = 'POST';
    const func: string = 'add';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseAddDto>>(method, url, params, urlParams, body);
  }

  public save(payload: RequestEditDto): Observable<ResponseData<ResponseSaveDto>> {
    const method: string = 'POST';
    const func: string = 'save';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseSaveDto>>(method, url, params, urlParams, body);
  }

  public delete(payload: RequestDeleteDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'delete';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  public updatePost(payload: RequestUpdatePostDto): Observable<ResponseSaveDto> {
    const method: string = 'POST';
    const func: string = 'updatePost';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSaveDto>(method, url, params, urlParams, body);
  }

  public feedCorrection(requestNo: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'feedCorrection';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof requestNo !== 'undefined' && requestNo !== null) urlParams.requestNo = requestNo;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/correction.api.ts